export const DEFAULT_DEBOUNCE_DELAY = 1000;

export const DEFAULT_INTERVAL = 1000;
export const DEFAULT_INITIAL_SECONDS = 30;
export const RESEND_ACCESS_CODE_SECONDS = 60;
export const ZERO_SECONDS = 0;
export const START_INDEX_STRING = 0;
export const END_CUT_INDEX_STRING = 2;